/**
 * NOTIF1 T17: one dispatcher for every palette proposal (useAssistantParser intents + pages + quick actions).
 * `h` = App navigation handlers; missing handlers are skipped.
 */
import { SETTINGS_SECTION } from '../../constants/settings';

export default function runProposal(proposal, h) {
  const { intent, payload = {} } = proposal;
  switch (intent) {
    case 'open_page':
      h.setCurrentView(payload.view);
      break;
    case 'open_tool':
      h.onNavigateTool?.(payload.href);
      break;
    case 'record_payment':
      if (payload.family) h.onOpenPayment?.({ ...payload.family, preAmount: payload.amount });
      else h.setCurrentView('payments');
      break;
    case 'generate_invoice':
      if (payload.family) h.onSelectFamily?.(payload.family);
      h.setCurrentView('generateInvoice', payload.preset ? { preset: payload.preset } : undefined);
      break;
    case 'attestation_sap':
      if (payload.family) h.onSelectFamily?.(payload.family);
      h.setCurrentView('generateInvoice', { preset: 'last-year' });
      break;
    case 'start_course':
      if (payload.student) h.onSelectStudent?.(payload.student);
      h.setCurrentView('startCourse');
      break;
    case 'view_student':
      if (payload.student) h.onViewStudentDetail?.(payload.student);
      break;
    case 'view_family':
      if (payload.family) h.onViewFamilyDetail?.(payload.family);
      break;
    case 'add_family':
      if (h.onAddFamilyForStudent) h.onAddFamilyForStudent();
      else h.setCurrentView('createFamily');
      break;
    case 'add_student':
      if (h.onAddStudent) h.onAddStudent();
      else h.setCurrentView('addStudent');
      break;
    case 'schedule':
      h.onNavigateSchedule?.(payload);
      break;
    case 'stats':
      if (payload.tab) h.onSetStatsTab?.(payload.tab);
      if (payload.scrollTo) h.onSetStatsScrollTo?.(payload.scrollTo);
      h.setCurrentView('statistics');
      break;
    case 'relance_all':
      h.onRelance?.(null);
      break;
    case 'relance_family':
      h.onRelance?.(payload.family || null);
      break;
    case 'urssaf':
      h.onSetStatsTab?.('revenues');
      h.onSetStatsScrollTo?.('declaration-summary');
      h.setCurrentView('statistics');
      break;
    case 'urssaf_credentials':
      h.openSettings?.(SETTINGS_SECTION.URSSAF);
      break;
    case 'settings':
      h.openSettings?.(SETTINGS_SECTION.PROFILE);
      break;
    default:
      // 'logout' and unknown intents: handled by the navigation avatar, not here.
      break;
  }
}
